import { ISessionActionRequired, ISessionAttendance, ISessionCategory } from '@wot/typings';
import { format } from 'date-fns-tz';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { HiCheckCircle } from 'react-icons/hi';
import { IoCloseCircleSharp } from 'react-icons/io5';
import { Button, Dropdown } from '../Elements';
interface Props {
  _id: string;
  status: string;
  startTime: Date;
  endTime: Date;
  category: ISessionCategory;
  type: 'trial' | 'plan';
  name: string;
  profilePic?: string;
  actionRequired?: ISessionActionRequired;
  showJoinBtn: boolean;
  showCancelBtn: boolean;
  showRescheduleBtn: boolean;
  showScheduleBtn?: boolean;
  showMarkAttendanceBtn?: boolean;
  onJoin?: any;
  onCancel?: () => void;
  onRescedule?: () => void;
  onSchedule?: () => void;
  onMarkAttendance?: () => void;
  onAttendanceIssue?: () => void;
  rescheduled?: 'user' | 'tutor';
  attendance?: ISessionAttendance;
  showKebabMenu?: boolean;
  menuOptions?: ['Report Issue'];
  markSelfAttendance?: boolean;
  onMarkSelfAttendance?: (attendance: 'present' | 'absent') => void;
}

export function ClassCard({
  _id,
  category,
  endTime,
  type,
  name,
  profilePic,
  startTime,
  status,
  actionRequired,
  showCancelBtn,
  showJoinBtn,
  showRescheduleBtn,
  showScheduleBtn,
  showMarkAttendanceBtn,
  rescheduled,
  attendance,
  showKebabMenu,
  // menuOptions,
  markSelfAttendance,
  onMarkAttendance = () => {
    return;
  },
  onSchedule = () => {
    return;
  },
  onCancel = () => {
    return;
  },
  onJoin = () => {
    return;
  },
  onRescedule = () => {
    return;
  },
  onAttendanceIssue = () => {
    return;
  },
  onMarkSelfAttendance = () => {
    return;
  }
}: Props) {
  return (
    <>
      <div
        className={`w-full max-w-lg relative flex flex-col gap-2 px-4 md:px-7 py-4 rounded-lg border border-l-4 overflow-hidden
    ${status === 'upcoming'
            ? ' border-[#2AB3BB]'
            : status === 'completed'
              ? 'border-[#9AD366]'
              : status === 'cancelled'
                ? 'border-[#FB8F8C]'
                : ''
          }`}
      >
        {type === 'trial' && (
          <div className="absolute top-0 right-0 badge bg-primary w-[30px] h-[34px] overflow-hidden ">
            <p className="text-sm font-semibold text-white text-right pr-2">T</p>
          </div>
        )}
        <div className="w-full flex flex-col gap-4">
          <div className="w-full flex flex-col gap-4">
            <div className="w-full flex items-center justify-between">
              <div className="flex items-center gap-2">
                {actionRequired ? (
                  <p className="text-sm font-medium text-error uppercase">Action Required</p>
                ) : (
                  <p className="text-sm font-medium text-gray-800 uppercase">{status}</p>
                )}
                {rescheduled && (
                  <div className="w-max px-4 border-l">
                    <p className="text-sm font-medium text-[#FCC240] uppercase">Rescheduled</p>
                  </div>
                )}
              </div>
              {showKebabMenu && (
                <Dropdown
                  placement="bottomLeft"
                  menu={[
                    {
                      key: 1,
                      label: (
                        <div
                          key={1}
                          onClick={() => onAttendanceIssue()}
                          className="flex items-center p-2 px-4 hover:bg-gray-100 cursor-pointer"
                        >
                          <p className="text-sm font-medium pr-2">Report Issue</p>
                        </div>
                      )
                    }
                  ]}
                >
                  <BsThreeDotsVertical className="text-base cursor-pointer" />
                </Dropdown>
              )}
            </div>
            <p className="text-sm font-normal">Class Id: {_id}</p>
            <div className="w-full flex flex-col md:flex-row items-start gap-4">
              <div className="w-full flex gap-4">
                <div className="max-w-[70px] w-max flex flex-col items-center pr-4 border-r-2 border-gray-400">
                  <p className="text-base md:text-xl font-semibold">{format(startTime, 'd')}</p>
                  <p className="text-sm font-medium">{format(startTime, 'LLL')}</p>
                </div>

                <div className="w-full flex flex-col justify-start grow gap-4 text-sm">
                  <div className="flex flex-col">
                    <p className="text-base md:text-xl font-semibold">
                      {format(startTime, 'p')} - {format(endTime, 'p')}
                    </p>
                    <p className="text-sm font-medium">{category.name} classes</p>
                  </div>
                </div>
              </div>
              <div className="shrink-0 flex md:flex-col items-center md:ml-auto gap-2">
                <div className="w-10 h-10 rounded-full overflow-hidden">
                  <img src={profilePic} className="w-full h-full object-cover" alt="image" />
                </div>
                <p className="text-sm font-medium text-center">{name}</p>
              </div>
            </div>
          </div>
          <div className="w-full flex items-center justify-center just gap-4 border-t pt-4">
            {showRescheduleBtn && (
              <div className="w-max max-w-[164px] flex items-center gap-4 grow">
                <Button block type="s-outlined" text="Reschedule Class" onClick={() => onRescedule()} />
              </div>
            )}
            {showCancelBtn && (
              <div className="w-max max-w-[164px] flex items-center gap-4 grow">
                <Button block type="s-outlined" text="Cancel Class" onClick={() => onCancel()} />
              </div>
            )}
            {showJoinBtn && (
              <div className="w-max max-w-[164px] flex items-center gap-4 grow">
                <Button type="primary" block onClick={() => onJoin()} text="Join Class" />
              </div>
            )}
            {showScheduleBtn && (
              <div className="w-max max-w-[164px] flex items-center gap-4 grow">
                <Button type="primary" block onClick={() => onSchedule()} text="Schedule" />
              </div>
            )}
            {showMarkAttendanceBtn && (
              <div className="w-max max-w-[164px] flex items-center gap-4 grow">
                <Button type="s-outlined" block onClick={() => onMarkAttendance()} text="Mark Attendance" />
              </div>
            )}
            {markSelfAttendance ? (
              <Dropdown
                placement="top"
                menu={[
                  {
                    key: 1,
                    label: (
                      <div
                        key={1}
                        onClick={() => onMarkSelfAttendance('present')}
                        className="flex items-center p-2 px-4 hover:bg-gray-100 cursor-pointer"
                      >
                        <p className="text-sm font-medium pr-2">Present</p>
                      </div>
                    )
                  },
                  {
                    key: 2,
                    label: (
                      <div
                        key={2}
                        onClick={() => onMarkSelfAttendance('absent')}
                        className="flex items-center p-2 px-4 hover:bg-gray-100 cursor-pointer"
                      >
                        <p className="text-sm font-medium pr-2">Absent</p>
                      </div>
                    )
                  }
                ]}
              >
                {attendance === 'present' ? (
                  <div className="flex items-center gap-1">
                    <HiCheckCircle className="text-bsae text-green-600" />
                    <p className="text-base font-semibold text-green-600">Present</p>
                  </div>
                ) : attendance === 'absent' ? (
                  <div className="flex items-center gap-1">
                    <IoCloseCircleSharp className="text-bsae text-red-600" />
                    <p className="text-base font-semibold text-red-600">Absent</p>
                  </div>
                ) : (
                  <div className="flex items-center gap-1">
                    <p className="text-base font-semibold text-gray-600">Pending</p>
                  </div>
                )}
              </Dropdown>
            ) : (
              <>
                {attendance === 'present' ? (
                  <div className="flex items-center gap-1">
                    <HiCheckCircle className="text-bsae text-green-600" />
                    <p className="text-base font-semibold text-green-600">Present</p>
                  </div>
                ) : attendance === 'absent' ? (
                  <div className="flex items-center gap-1">
                    <IoCloseCircleSharp className="text-bsae text-red-600" />
                    <p className="text-base font-semibold text-red-600">Absent</p>
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
